type TicketEmail = { email: string };

export const firstTicketEmail = (tickets: TicketEmail[]) => tickets[0]?.email ?? '';

export const deriveBuyerEmail = (tickets: TicketEmail[], buyerEmail: string) =>
  tickets.length === 1 ? firstTicketEmail(tickets) : buyerEmail || firstTicketEmail(tickets);

export const nextTicketOrderState = ({
  tickets,
  buyerEmail,
  previousFirstTicketEmail,
}: {
  tickets: TicketEmail[];
  buyerEmail: string;
  previousFirstTicketEmail?: string;
}) => {
  const nextFirstTicketEmail = firstTicketEmail(tickets);
  const shouldFollowFirstTicketEmail =
    !buyerEmail || buyerEmail === (previousFirstTicketEmail ?? '');

  return {
    buyerEmail: shouldFollowFirstTicketEmail ? nextFirstTicketEmail : buyerEmail,
    firstTicketEmail: nextFirstTicketEmail,
  };
};
